import { render, staticRenderFns } from "./changeHeadIcon.vue?vue&type=template&id=6f8a5c02&scoped=true&"
import script from "./changeHeadIcon.vue?vue&type=script&lang=js&"
export * from "./changeHeadIcon.vue?vue&type=script&lang=js&"
import style0 from "./changeHeadIcon.vue?vue&type=style&index=0&lang=css&"
import style1 from "./changeHeadIcon.vue?vue&type=style&index=1&id=6f8a5c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a5c02",
  null
  
)

export default component.exports